import React from "react";
import { IonItem, IonLabel, IonText } from "@ionic/react";
import { EquipmentModel } from "../models/GlobalModels";

import "./EquipmentItem.scss";

interface Props {
    equipment: EquipmentModel;
}

const EquipmentItem: React.FC<Props> = ({ equipment }) => {
    return (
        <div className="equipmentItemWrapper">
            <IonItem lines="none" button={false} detail={false}>
                <IonLabel>
                    <h2 className="title">
                        <IonText>{equipment.name ?? ""}</IonText>
                    </h2>
                    {(equipment?.serialNumber ?? "") !== "" && (
                        <IonText>
                            <small>
                                Leltári szám: <b>{equipment.serialNumber}</b>
                            </small>
                        </IonText>
                    )}
                    {(equipment?.serialNumber ?? "") === "" && (
                        <IonText>
                            <small>
                                Mennyiség: <b>{equipment?.quantity ?? 0} db</b>
                            </small>
                        </IonText>
                    )}
                </IonLabel>
            </IonItem>
        </div>
    );
};

export default EquipmentItem;
